import { render, staticRenderFns } from "./ProjectAssignment.vue?vue&type=template&id=5f0f49f2&scoped=true"
import script from "./ProjectAssignment.vue?vue&type=script&lang=js"
export * from "./ProjectAssignment.vue?vue&type=script&lang=js"
import style0 from "./ProjectAssignment.vue?vue&type=style&index=0&id=5f0f49f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0f49f2",
  null
  
)

export default component.exports